import axios from 'axios'

import config from '../../config'

const updateWorkOrderReminder = (params = {}, data) => {
  const { airportId } = params

  const url = `${config.baseUrl}/${airportId}/Reminders/WorkOrder`
  return axios.put(url, data)
}

export default updateWorkOrderReminder
